import React, { useEffect } from 'react';
import { Form, Field, Formik } from 'formik';
import { Link } from 'react-router-dom';
import * as Yup from 'yup';
import qs from 'qs';

import { connect } from 'react-redux';
import { login, autoLogin } from '../../redux/actions/authActions';

const pControl = {
    height: "40px",
    borderRadius: '10px',
    outline: 'none',
    color: 'black',
    padding: '10px'
}

const LoginView = (props) => {
    const initialValues = {
        username: '',
        password: ''
    }

    const validateSchema = Yup.object().shape({
        username: Yup.string().required('username Required'),
        password: Yup.string().required('password Required'),
    })

    const handleSubmit = (values) => {
        let username = values.username
        let password = values.password
        let loginData = {
            username: username,
            password: password
        }
        props.login(loginData)
    }

    return (
        <React.Fragment>
            <div className='container'>
                <div className="row">
                    <div className="col-md-4 col-sm-4 offset-md-4 w3-white w3-card mt-5 w3-round-xxlarge">
                        <div className="row">
                            <div className="col-md-2 col-sm-2 mt-5 offset-md-4">
                                <img className="p-1 m1-4" alt="logo" src="assets/svg/books.svg" width="60" style={{ marginLeft: '20px' }} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-10 col-sm-10 mt-0 offset-md-1">
                                <p className="font-weight-bolder titleName text-center w3-text-blue" style={{ color: '#2196F3' }}>Supply Chain Control Tower</p>
                            </div>
                        </div>
                        <Formik
                            initialValues={initialValues}
                            validationSchema={validateSchema}
                            onSubmit={handleSubmit}
                        >
                            {({ values, isSubmitting, errors, touched }) => (
                                <Form>
                                    <div className="row">
                                        <div className="col-md-10 offset-md-1 col-sm-10 offset-sm-1">
                                            <div className="text-center mt-3 ml-5 mr-5">
                                                <Field name="username" className="form-contol w3-card w3-border w3-hover-border-blue" style={pControl} type="text" placeholder="username" />
                                                {touched.username && errors.username && <small>{errors.username}</small>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-10 offset-md-1 col-sm-10 offset-sm-1">
                                            <div className="text-center mt-4 mb-2 ml-5 mr-5">
                                                <Field name="password" className="form-contol w3-card w3-border w3-hover-border-blue" style={pControl} type="password" placeholder="password" />
                                                {touched.password && errors.password && <small>{errors.password}</small>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-10 offset-md-1 col-sm-10 offset-sm-1">
                                            <div className="text-center mt-4 mb-5 ml-5 mr-5">
                                                <input className="form-check-input small" type="checkbox" value="" id="invalidCheck" />
                                                <label className="form-check-label small" htmlFor="invalidCheck">
                                                    Remember Me
                                                </label>
                                                <p><button type="submit" disabled={isSubmitting} className="w3-button p-outline-none mt-4 p-btn w3-blue w3-round-xlarge w3-large"><small>Sign In</small></button></p>
                                                <small> forgot <Link to="#"><b>password & username</b></Link></small>
                                            </div>
                                        </div>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default connect(null, { login, autoLogin })(LoginView)
